import { useState } from 'react';
import { apiFetch } from '../../lib/api-client.js';

export interface Permission {
  id: string | number;
  module: string;
  can_grant?: boolean;
  granted_by_email?: string;
  granted_at?: string;
  revoked_at?: string | null;
  revoked_by_email?: string | null;
  notes?: string;
}

interface PermissionsResponse {
  active?: Permission[];
  revoked?: Permission[];
  error?: string;
}

export function usePermissionsReadModel() {
  const [targetEmail, setTargetEmail] = useState('');
  const [active, setActive] = useState<Permission[]>([]);
  const [revoked, setRevoked] = useState<Permission[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  async function loadPermissions(email: string) {
    if (!email || !email.includes('@')) return;
    setLoading(true);
    setError(null);
    setTargetEmail(email);

    try {
      const data = await apiFetch<PermissionsResponse>(`/api/permissions/${encodeURIComponent(email)}`);
      if (data.error) {
        setError(data.error);
        setActive([]);
        setRevoked([]);
      } else {
        setActive(data.active || []);
        setRevoked(data.revoked || []);
      }
      setLoaded(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load permissions');
      setActive([]);
      setRevoked([]);
    } finally {
      setLoading(false);
    }
  }

  function updateFromResponse(data: PermissionsResponse) {
    setActive(data.active || []);
    setRevoked(data.revoked || []);
  }

  return {
    targetEmail,
    active,
    revoked,
    loading,
    error,
    loaded,
    loadPermissions,
    updateFromResponse,
  };
}
